import gsap from "gsap"

export async function resolveAndKillTweens(targets) {
    const tweens = gsap.getTweensOf(targets)
    for (const tween of tweens) {
        if ((tween)._prom) (tween)._prom()
    }
    gsap.killTweensOf(targets)
}

export async function tweenFadeAppear(gameObject, isVisible, timeDuration = 0.2, cb = () => { }) {
    if (!gameObject) return
    if (!gameObject?.initialX) gameObject.initialX = gameObject.x
    if (!gameObject?.finalY) gameObject.finalY = gameObject.y
    if (!gameObject?.finalX) gameObject.finalX = gameObject.x
    if (!gameObject?.finalY) gameObject.finalY = gameObject.y

    const xPos = isVisible ? gameObject.finalX : gameObject.initialX
    const yPos = isVisible ? gameObject.finalY : gameObject.initialY
    const duration = timeDuration

    if (isVisible) {
        gameObject.visible = true
        gameObject.alpha = isVisible ? 0 : 1
    }

    resolveAndKillTweens(gameObject)
    const tl = gsap.timeline()
    await tl.to(gameObject, {
        x: xPos,
        y: yPos,
        alpha: isVisible ? 1 : 0,
        duration,
        ease: 'sine.in',
        onComplete: () => {
            gameObject.visible = isVisible
            cb()
            return
        }
    })
}

export const tweenFade = async (gameObject, isVisible, duration = 0.2, cb = () => { }) => {
    gameObject.visible = true
    resolveAndKillTweens(gameObject)
    const tl = gsap.timeline()
    await tl.to(gameObject, {
        alpha: isVisible ? 1 : 0,
        duration,
        ease: 'sine.in',
        onComplete: cb
    })
}

export const tweenScaleAppear = async (gameObject, duration = 0.2, callbackFunction = () => { }) => {
    resolveAndKillTweens(gameObject)
    const tl = gsap.timeline()
    await tl.to(gameObject, {
        pixi: {
            scale: 2
        },
        duration: duration * 0.5,
        ease: 'power1.in'
    })
        .to(gameObject, {
            pixi: {
                scale: 1
            },
            duration: duration * 0.5,
            ease: 'power1.out',
            onComplete: () => {
                callbackFunction()
                return
            }
        })
}

export const tweenScaleDisAppear = async (gameObject, duration = 0.2, callbackFunction = () => { }) => {
    resolveAndKillTweens(gameObject)
    const tl = gsap.timeline()
    await tl.to(gameObject, {
        pixi: {
            scale: 0
        },
        duration,
        ease: 'power2',
        onComplete: () => {
            callbackFunction()
            return
        }
    })
}

export const incrementValue = async (gameObject, value, duration) => {
    const tl = gsap.timeline()

    tl.to(gameObject, {
        duration: duration - 4,
        repeat: 1,
        repeatDelay: Infinity,
        ease: "expo.out",
        onUpdate: function () {
            const amount = (Math.floor(this.progress() * value * 100) / 100).toFixed(2)
            gameObject.text = amount
        },
        onComplete: function () {
            tl.kill()
        }
    })
}

export function animateWinNumber(obj) {
    
    const winNumber = obj;

    gsap.killTweensOf(winNumber);

    winNumber.alpha = 1;
    winNumber.scale.set(1);

    gsap.to(winNumber.scale, {
        x: 1.2,
        y: 1.2,
        duration: 0.4,
        ease: "power2.out",
        yoyo: true,
        repeat: 1,
        onComplete: () => {
            gsap.to(winNumber, {
                alpha: 0,
                duration: 0.5,
                ease: "power1.out",
            });
        }
    });
}

export function tweenPulsate(gameObject, timeDuration = 1, scaleFactor = 0.8, times = -1) {
    if (!gameObject || typeof gameObject.alpha !== "number") return;

    // Ensure no other tweens interfere with this object    
    gsap.killTweensOf(gameObject);

    // Create a repeating timeline for the siren effect
    gsap.timeline({ repeat: times, yoyo: true }) // Repeat indefinitely with smooth yoyo effect
        .to(gameObject, {
            pixi: {
                scale: scaleFactor
            },
            duration: timeDuration,
            ease: "power1.inOut", // Smooth easing
        });
}
